<div class="modern-block-card" tabindex="0" (keypress)="enterItemByKeyboard($event)"
     [ngClass]="{'pinned':item.pinnedTime}" (click)="showDetails()">

    <div class="modern-block-image" [class.promotion-wrap]="item.isPromotionImage">
        <!--<img [src]="imageService.safeImage(imageService.imageSourceUrl(item.cover?.source))" class="image"-->
        <!--[class.promotion]="item.isPromotionImage" />-->
        <ig-image [imageUrl]="item.cover?.source" [placeCategoryList]="item.categoryList"
                  [class.promotion]="item.isPromotionImage" [alt]="item.title||item.name"></ig-image>
        <div *ngIf="item.startTime&&!item.isPromotionImage" class="ig-host-time">
            <div class="modern-block-time" *ngIf="item.eventTimes&&item.eventTimes.length<=1">
                <div class="left">
                    <div *ngIf="!isSimple">
                        <div *ngIf="item.startTimeText" class="first-time">
                            <ng-container *ngIf="!item.isNoTime">
                                <!--                                <span class="day">-->
                                <!--                                    {{eventTimeText.date[0].split(" ")[1]}}-->
                                <!--                                </span>-->
                                <span class="month">
<!--                                    {{eventTimeText.date[0].split(" ")[2]}}-->
<!--                                    {{item.eventTimes[0].month}} {{item.eventTimes[0].day}}, {{item.eventTimes[0].year}}-->
                                    <span>{{eventTimeText.eventDate}}</span>
                                </span>
                            </ng-container>
                            <ng-container *ngIf="item.isNoTime">
                                <!--                                <span *ngIf="isSimple">{{item['noTimeFormatted'].split(' - ')[0]}}</span>-->
                                <span>{{item['noTimeFormatted']}}</span>
                            </ng-container>
                        </div>
                        <div class="step-time">
<!--                            <span class="week-day">{{eventTimeText.week_day}}.</span>-->
                            <ng-container *ngIf="item.isNoTime">
                                <!--                                <span *ngIf="isSimple">{{item['noTimeFormatted'].split(' - ')[0]}}</span>-->
                                <span>{{item['noTimeFormatted']}}</span>
                            </ng-container>
                            <ng-container *ngIf="!item.isNoTime">
<!--                                <span>{{eventTimeText.date[1]}}</span>-->
                                <span>{{eventTimeText.time}}</span>
                                <span *ngIf="item.startTimeText&&!isSimple">({{item.timezone}})</span>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="isSimple" class="title-simple">
                        {{item.title || item.name}}
                    </div>
                </div>
                <div class="right">
                    <mat-icon>add</mat-icon>
                </div>
            </div>

            <div class="modern-block-time" *ngIf="item.eventTimes&&item.eventTimes.length>1">
                <span *ngIf="!isSimple" class="multi-dates left">Multiple Dates Event</span>
                <span *ngIf="isSimple" class="multi-dates left"
                      style="font-weight: normal">{{item.title || item.name}}</span>
                <div class="right">
                    <mat-icon>add</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!isSimple" class="modern-block-content" [class.promotion-content]="item.isPromotionImage">
        <div class="choice" *ngIf="item.isChoice">
            <span class="choice-bg">{{editorChoiceText}}</span>
        </div>
        <div class="hosted-by" *ngIf="item.owner?.name">
            <span class="label">hosted by:</span> {{item.owner.name}}
        </div>
        <div *ngIf="!item.isPromotionImage" class="ig-title">
            <p>{{item.title || item.name}}</p>
        </div>
        <div class="event-info">
            <span *ngIf="item['venue']">{{item.venue}}, </span>
            <span *ngIf="item.address?.address">{{item.address.address}}</span>
        </div>

    </div>

    <!-- <div *ngIf="!item.isPromotionImage" class="detail-btn-wrap" role="button">
        details
    </div> -->

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/modern.block.card/visitor.modern.block.card.component.html